import React, { useEffect } from 'react';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import classNames from 'classnames';
import styles from './index.module.scss';
configureAnchors({ offset: -134, scrollDuration: 200 });

const Tabs = (props: { tabData: any[]; onSelectChanged: (id: string) => void; selectedKeys: string }): any => {
  const { tabData, onSelectChanged, selectedKeys } = props;
  // const arr = Object.keys(tabData); // 由tab标签名组成的数组
  // const [selected, setSelected] = useState(selectedKeys); // 当前选中的tab标签
  useEffect(() => {
    window.location.hash = '';
  }, []);
  function select(id) {
    // setSelected(id);
    onSelectChanged(id);
  }
  return (
    <div className={styles.tabs}>
      <div className={styles.tabsHeaderContent}>
        <div className={classNames('flex-row-nowrap', 'flex-around-center', styles.tabsHeader)}>
          {tabData.map(item => (
            <div className={styles.selectItem} key={item.id}>
              <a
                className={
                  item.id === selectedKeys
                    ? classNames(styles.selectItemBasic, styles.selectItemActive)
                    : styles.selectItemBasic
                }
                href={`#tabs-${item.id}`}
                onClick={() => select(item.id)}
              >
                {item.name}
              </a>
            </div>
          ))}
        </div>
      </div>
      {/* {tabData.map((item, index) => (
        <div
          className={item.id === selected ? classNames(styles.tabsBody, styles.tabsBodyShow) : styles.tabsBody}
          key={index}
        >
          {item.name}
        </div>
      ))} */}
      {tabData.map(item => (
        <ScrollableAnchor id={`tabs-${item.id}`} key={item.id}>
          <div>{item.content}</div>
        </ScrollableAnchor>
      ))}
    </div>
  );
};
export default Tabs;
